module.exports = __webpack_public_path__ + "static/python-1bbd6468123733ff68286e736a335414.png";